import { render, staticRenderFns } from "./MediumCategoryList.vue?vue&type=template&id=406b0948&"
import script from "./MediumCategoryList.vue?vue&type=script&lang=js&"
export * from "./MediumCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./MediumCategoryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports